const removeMask = (value) => {
    return value.replace(/\D/g, '');
};
const applyCPFMask = (value) => {
    const numbers = removeMask(value);
    return numbers
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1');
};
const applyCEPMask = (value) => {
    const numbers = removeMask(value);
    return numbers
        .replace(/(\d{5})(\d)/, '$1-$2')
        .replace(/(-\d{3})\d+?$/, '$1');
};
const applyTelephoneMask = (value) => {
    const numbers = removeMask(value);
    if (numbers.length <= 10) {
        return numbers
            .replace(/(\d{2})(\d)/, '($1) $2')
            .replace(/(\d{4})(\d)/, '$1-$2')
            .replace(/(-\d{4})\d+?$/, '$1');
    }
    else {
        return numbers
            .replace(/(\d{2})(\d)/, '($1) $2')
            .replace(/(\d{5})(\d)/, '$1-$2')
            .replace(/(-\d{4})\d+?$/, '$1');
    }
};
const applyDateMask = (value) => {
    const numbers = removeMask(value);
    return numbers
        .replace(/(\d{2})(\d)/, '$1/$2')
        .replace(/(\d{2})(\d)/, '$1/$2')
        .replace(/(\d{4})\d+?$/, '$1');
};
const applyMoneyMask = (value) => {
    const numbers = removeMask(value);
    if (!numbers)
        return '';
    const numericValue = parseInt(numbers, 10) / 100;
    return 'R$ ' + numericValue.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};
export const applyMask = (value, maskType) => {
    if (maskType === 'none' || !value)
        return value;
    switch (maskType) {
        case 'cpf':
            return applyCPFMask(value);
        case 'cep':
            return applyCEPMask(value);
        case 'telephone':
            return applyTelephoneMask(value);
        case 'date':
            return applyDateMask(value);
        case 'money':
            return applyMoneyMask(value);
        default:
            return value;
    }
};
export const getMaxLength = (maskType) => {
    switch (maskType) {
        case 'cpf':
            return 14;
        case 'cep':
            return 9;
        case 'telephone':
            return 15;
        case 'date':
            return 10;
        case 'money':
            return 20;
        default:
            return undefined;
    }
};
export const getPlaceholder = (maskType) => {
    switch (maskType) {
        case 'cpf':
            return '000.000.000-00';
        case 'cep':
            return '00000-000';
        case 'telephone':
            return '(00) 00000-0000';
        case 'date':
            return 'DD/MM/AAAA';
        case 'money':
            return 'R$ 0,00';
        default:
            return 'Digite aqui...';
    }
};
export const getUnmaskedValue = (value, maskType) => {
    if (maskType === 'money') {
        return value
            .replace(/R\$\s?/g, '')
            .replace(/\./g, '')
            .replace(/,/, '.');
    }
    return removeMask(value);
};
//# sourceMappingURL=inputMasks.js.map